import React from "react";

const CustomToolbar: React.FC<{id?: string}> = ({ id = "toolbar" }) => (
  <div id={id}>
    <span className="ql-formats">
      <button className="ql-bold" />
      <button className="ql-italic" />
      <button className="ql-underline" />
    </span>

    <span className="ql-formats">
      <select className="ql-align" />
    </span>

    <span className="ql-formats">
      <button className="ql-list" value="ordered" />
      <button className="ql-list" value="bullet" />
    </span>

    <span className="ql-formats">
      <button className="ql-link" />
      <button className="ql-clean" />
    </span>

    <span className="ql-formats">
      <button className="ql-code" />
    </span>
  </div>
);

export default CustomToolbar;
